class PDPGallery extends SiteCarousel {
  constructor() {
    super();
    this._handleSlideClick = null;
    this._slidesRoot = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.selectedSlideIndex = +(this.dataset.selectedSlideIndex || "0");

    this._slidesRoot = this.querySelector(".swiper-wrapper") || this.querySelector(".swiper");

    this._handleSlideClick = (e) => {
      if (!window.matchMedia("(min-width: 1024px)").matches) return;

      const interactive = e.target.closest("button, a, .carousel-next, .carousel-prev, .carousel-pager");
      if (interactive) return;

      if (!this.swiper) return;

      const total = this.swiper.slides?.length || 0;
      if (total <= 1) return;

      const current = typeof this.swiper.realIndex === "number" ? this.swiper.realIndex : this.swiper.activeIndex || 0;

      if (current >= total - 1) {
        this.swiper.slideTo(0);
      } else {
        this.swiper.slideNext();
      }
    };

    this._slidesRoot?.addEventListener("click", this._handleSlideClick);

    this.swiper?.slideTo(this.selectedSlideIndex, 0);
  }

  disconnectedCallback() {
    if (this._slidesRoot && this._handleSlideClick) {
      this._slidesRoot.removeEventListener("click", this._handleSlideClick);
    }
  }
}

customElements.define("pdp-gallery", PDPGallery);
